import { render, staticRenderFns } from "./ParamsCall.vue?vue&type=template&id=95a68034&scoped=true"
import script from "./ParamsCall.vue?vue&type=script&lang=js"
export * from "./ParamsCall.vue?vue&type=script&lang=js"
import style0 from "./ParamsCall.vue?vue&type=style&index=0&id=95a68034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a68034",
  null
  
)

export default component.exports